import React from 'react'
import Box from '@mui/material/Box'

import {ChevronDown} from 'src/assets/icons'

import type {Theme} from '@mui/material'

const CompanyTitleContrast = () => (
  <Box
    sx={{
      width: 32,
      height: 32,
      margin: '0 auto',
      pt: 0.5,
      borderRadius: 10,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: (theme: Theme) =>
        `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
    }}
  >
    <ChevronDown />
  </Box>
)

export default CompanyTitleContrast
